import React from "react";
import './Banner.css';

export default function Banner(props) {
    return (
        <div id="bannerWrapper" class="bannerWrapper" onLoadedData={() => setStickyHeight()}>
            {window.onresize = function () { resizeHandler() }}
            {props.isVideo ? <video autoPlay muted loop id="banner" class="banner" src={"/media/Banners/" + props.src} type="video/mp4" onLoadedData={(event) => event.target.playbackRate = "0.75"}/> :
                <img id="banner" class="banner" src={"/media/Banners/" + props.src} onLoad={() => setStickyHeight()} />}
        </div>
    );
}

//Helper functions
function setStickyHeight() {
    const navbar = document.getElementById("navbar");
    const bannerWrapper = document.getElementById("bannerWrapper");
    const banner = document.getElementById("banner");

    //keeps the bottom part of the banner image stuck behind the navbar.
    bannerWrapper.style.top = navbar.offsetHeight - banner.offsetHeight + "px";

    return;
}

function resizeHandler() {
    setStickyHeight();
}